import { render, staticRenderFns } from "./SaleAIAiContext.vue?vue&type=template&id=35810214"
import script from "./SaleAIAiContext.vue?vue&type=script&lang=js"
export * from "./SaleAIAiContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports